import { Container, Row, Col } from "react-bootstrap";

export const Resume = () => {
  return (
    <section className="resume-section" id="resume">
      <Container>
        <Row>
          <Col>
            <div className="resume-header">
              <h2>Resume</h2>
              <p className="resume-subtitle">My Education, Skills & Experience</p>
            </div>
          </Col>
        </Row>

        <Row className="resume-content">
          {/* LEFT COLUMN */}
          <Col lg={6} className="resume-col">

            {/* Summary */}
            <div className="resume-block">
              <div className="resume-block-title">
                <span className="resume-icon">👤</span>
                <h3>About Me</h3>
              </div>
              <p className="resume-summary">
                Motivated Computer Science & Engineering student focused on MERN stack web development.
                Skilled in building responsive, user-friendly websites. Strong teamwork, leadership,
                and communication skills gained through club and association roles.
              </p>
            </div>

            {/* Education */}
            <div className="resume-block">
              <div className="resume-block-title">
                <span className="resume-icon">🎓</span>
                <h3>Education</h3>
              </div>

              <div className="resume-item">
                <div className="resume-item-header">
                  <h4>B.Sc. in Computer Science & Engineering</h4>
                  <span className="resume-badge">Aug 2022 – Present</span>
                </div>
                <p className="resume-place">Port City International University, Chattogram</p>
                <p className="resume-detail">CGPA: 3.20</p>
              </div>

              <div className="resume-item">
                <div className="resume-item-header">
                  <h4>Higher Secondary Certificate (Alim)</h4>
                  <span className="resume-badge">2018 – 2020</span>
                </div>
                <p className="resume-place">Baitush Sharaf Adarsha Kamil Madrasa</p>
                <p className="resume-detail">GPA: 4.25</p>
              </div>

              <div className="resume-item">
                <div className="resume-item-header">
                  <h4>Complete Web Development Course</h4>
                  <span className="resume-badge">2024 – Present</span>
                </div>
                <p className="resume-place">Programming Hero</p>
                <p className="resume-detail">HTML, CSS, JavaScript, React, Backend fundamentals</p>
              </div>
            </div>

          </Col>

          {/* RIGHT COLUMN */}
          <Col lg={6} className="resume-col">

            {/* Skills */}
            <div className="resume-block">
              <div className="resume-block-title">
                <span className="resume-icon">⚡</span>
                <h3>Technical Skills</h3>
              </div>

              <div className="skill-category">
                <span className="skill-label">Frontend</span>
                <div className="skill-tags">
                  {["HTML5", "CSS3", "JavaScript", "React", "Tailwind CSS", "Bootstrap", "UI/UX"].map(s => (
                    <span key={s} className="skill-tag">{s}</span>
                  ))}
                </div>
              </div>

              <div className="skill-category">
                <span className="skill-label">Backend & DB</span>
                <div className="skill-tags">
                  {["Node.js", "Express.js", "MongoDB", "REST API", "MySQL"].map(s => (
                    <span key={s} className="skill-tag">{s}</span>
                  ))}
                </div>
              </div>

              <div className="skill-category">
                <span className="skill-label">Programming & Tools</span>
                <div className="skill-tags">
                  {["C", "C++", "Python", "GitHub", "VS Code", "Google Colab"].map(s => (
                    <span key={s} className="skill-tag">{s}</span>
                  ))}
                </div>
              </div>

              <div className="skill-category">
                <span className="skill-label">Soft Skills</span>
                <div className="skill-tags">
                  {["Teamwork", "Leadership", "Communication", "Management"].map(s => (
                    <span key={s} className="skill-tag skill-tag-soft">{s}</span>
                  ))}
                </div>
              </div>
            </div>

            {/* Experience */}
            <div className="resume-block">
              <div className="resume-block-title">
                <span className="resume-icon">🏆</span>
                <h3>Experience & Leadership</h3>
              </div>

              <div className="resume-item">
                <div className="resume-item-header">
                  <h4>Treasurer</h4>
                  <span className="resume-badge">Nov 2025 – Present</span>
                </div>
                <p className="resume-place">PCIU Computer Club</p>
                <p className="resume-detail">Managed financial records, budgeting, and helped organize tech events & workshops.</p>
              </div>

              <div className="resume-item">
                <div className="resume-item-header">
                  <h4>Organizational Secretary</h4>
                  <span className="resume-badge">Jan 2025 – Jan 2026</span>
                </div>
                <p className="resume-place">Cox's Bazar Students' Association, PCIU</p>
                <p className="resume-detail">Coordinated events, meetings, and student activities.</p>
              </div>

              <div className="resume-item">
                <div className="resume-item-header">
                  <h4>General Secretary</h4>
                  <span className="resume-badge">Feb 2019 – Feb 2020</span>
                </div>
                <p className="resume-place">Youth Alliance for Sustainable International Development (YASID)</p>
                <p className="resume-detail">Led team coordination and community-focused awareness programs.</p>
              </div>
            </div>

          </Col>
        </Row>

        {/* Download Button */}
        <Row>
          <Col className="text-center">
            <a
              href="/Abu_Bin_Naser_CV_.pdf"
              download="Abu_Bin_Naser_CV.pdf"
              className="resume-download-btn"
            >
              <span>Download CV</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
              </svg>
            </a>
          </Col>
        </Row>

      </Container>
    </section>
  );
};
